import { AxesSkeleton, PathSkeleton, Skeleton } from '@Components/Skeleton';

const POINTS_PRIMARY = [
  [0.65, 0.67, 0.64, 0.66, 0.69, 0.71, 0.68, 0.7, 0.73, 0.71, 0.74, 0.76, 0.78, 0.75, 0.77],
  [0.38, 0.36, 0.34, 0.37, 0.35, 0.33, 0.31, 0.29, 0.32, 0.3, 0.27, 0.29, 0.26, 0.24, 0.22],
  [0.42, 0.44, 0.41, 0.43, 0.46, 0.48, 0.45, 0.47, 0.5, 0.48, 0.51, 0.53, 0.55, 0.52, 0.54],
  [0.3, 0.32, 0.29, 0.31, 0.28, 0.3, 0.27, 0.29, 0.26, 0.28, 0.25, 0.27, 0.24, 0.26, 0.23]
] as const;

const POINTS_SECONDARY = [
  [0.72, 0.74, 0.71, 0.73, 0.76, 0.78, 0.75, 0.77, 0.8, 0.78, 0.81, 0.83, 0.85, 0.82, 0.84],
  [0.33, 0.35, 0.37, 0.34, 0.36, 0.39, 0.37, 0.4, 0.42, 0.39, 0.41, 0.44, 0.42, 0.45, 0.47],
  [0.45, 0.43, 0.46, 0.44, 0.41, 0.43, 0.4, 0.38, 0.41, 0.39, 0.36, 0.38, 0.35, 0.33, 0.31],
  [0.38, 0.4, 0.37, 0.39, 0.36, 0.38, 0.35, 0.37, 0.34, 0.36, 0.33, 0.35, 0.32, 0.34, 0.31]
] as const;

export const BenchmarkingSkeleton = () => (
  <div className='benchmarking-skeleton-container' data-testid='benchmarking-skeleton'>
    {[POINTS_PRIMARY, POINTS_SECONDARY].map((pointsData, dataIndex) => (
      <div className='loading-skeleton' key={`channelBenchmarkingSkeleton${dataIndex}`}>
        <Skeleton>
          {pointsData.map((points, pointsIndex) => (
            <PathSkeleton
              key={`skeletonPath${pointsIndex}`}
              points={points.map((p, pIndex, arr) => [pIndex / (arr.length - 1), p] as const)}
            />
          ))}
          <AxesSkeleton size={3} />
        </Skeleton>
      </div>
    ))}
  </div>
);
